import { ajax } from "@utils";

export const accessCardService = {
  /**
   * 取得建案門禁卡列表
   * @key SearchConstructionAccessCardByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getAll: (constructionUuid, condition) => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/access-cards`,
        {
          params: {
            ...condition
          }
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 新增建案門禁卡
   * @key CreateConstructionAccessCardByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 門禁卡資訊
   * @returns
   */
  create: (constructionUuid, info) => {
    return ajax
      .post(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/access-cards`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 刪除建案門禁卡
   * @key DeleteConstructionAccessCardByProperty
   * @param {number} id - 門禁卡 id
   * @returns
   */
  delete: id => {
    return ajax
      .delete(`${process.env.REACT_APP_API_URL}/property/access-cards/${id}`)
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 取得門禁卡 by 門禁卡號碼
   * @key GetConstructionAccessCardNumberByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {string} cardNumber - 門禁卡號碼
   * @returns
   */
  getByNumber: (constructionUuid, cardNumber) => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/access-cards/${cardNumber}`
      )
      .then(response => response.json())
      .then(res => {
        if (res.status === 400) {
          return Promise.reject({
            ...res,
            isNotFound: true,
            message: res.message
          });
        }

        if (res.status !== 200) {
          return Promise.reject({
            ...res,
            isNotFound: false,
            message: res.message
          });
        }

        return res.data;
      });
  },
  /**
   * 取得門禁卡 by 門禁卡 id
   * @key GetConstructionAccessCardByProperty
   * @param {number} id - 門禁卡 id
   * @returns
   */
  get: id => {
    return ajax
      .get(`${process.env.REACT_APP_API_URL}/property/access-cards/${id}`)
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 修改門禁卡資料
   * @key UpdateConstructionAccessCardByProperty
   * @param {number} id - 門禁卡 id
   * @param {object} info - 門禁卡資訊
   * @returns
   */
  update: (id, info) => {
    return ajax
      .put(`${process.env.REACT_APP_API_URL}/property/access-cards/${id}`, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...info
        })
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  }
};
